import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNpay = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 12,
	viewBox: "0 0 34 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_5142_2437)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M11.4187 5.70937C11.4187 6.83857 11.0839 7.9424 10.4566 8.88133C9.8292 9.82021 8.9375 10.552 7.89424 10.9841C6.85098 11.4162 5.70303 11.5293 4.59553 11.309C3.48802 11.0887 2.47071 10.545 1.67224 9.74651C0.873767 8.94803 0.330004 7.93072 0.109707 6.82321C-0.11059 5.7157 0.00247202 4.56774 0.434601 3.52448C0.866729 2.48123 1.59851 1.58955 2.53741 0.962199C3.47632 0.334848 4.58016 0 5.70937 0C7.2236 0 8.6758 0.601523 9.74651 1.67224C10.8172 2.74295 11.4187 4.19515 11.4187 5.70937ZM6.66429 3.02596V5.89632L4.66599 3.02596H3.02596V8.39993H4.75305V5.52096L6.75133 8.39277H8.39708V3.02596H6.66429Z",
			fill: "#00DE5A"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M32.1246 2.72776L30.5316 6.35769L28.7295 2.72776H27.344L29.8961 7.76384L28.844 10.1236H30.1895L33.4701 2.73492L32.1246 2.72776ZM26.4585 8.34089H25.1417V7.81681C24.6626 8.23668 24.0451 8.46422 23.4083 8.45547C21.8338 8.45547 20.6015 7.16673 20.6015 5.53434C20.6015 3.90194 21.8324 2.61321 23.4083 2.61321C24.0449 2.60404 24.6624 2.83104 25.1417 3.25041V2.72776H26.4585V8.34089ZM25.2962 5.54147C25.2962 4.4833 24.5577 3.67999 23.5786 3.67999C22.5996 3.67999 21.861 4.4833 21.861 5.54147C21.861 6.59969 22.5982 7.40296 23.5786 7.40296C24.5591 7.40296 25.2962 6.59251 25.2962 5.54147ZM14.0893 10.1236H15.4633V7.86407C15.9335 8.25518 16.5281 8.46495 17.1394 8.45547C18.7139 8.45547 19.9477 7.16673 19.9477 5.53434C19.9477 3.90194 18.7153 2.61321 17.1394 2.61321C16.5011 2.60174 15.8815 2.82896 15.4018 3.25041V2.72776H14.085L14.0893 10.1236ZM16.9763 3.67999C17.9553 3.67999 18.6939 4.4833 18.6939 5.54147C18.6939 6.59969 17.9553 7.40296 16.9763 7.40296C15.9972 7.40296 15.2587 6.59969 15.2587 5.54147C15.2587 4.4833 15.9886 3.67999 16.9763 3.67999Z",
			fill: "#00DE5A"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5142_2437",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 33.4701,
			height: 11.4187,
			fill: "white"
		})
	}) })]
});
export default SvgNpay;
